module.exports = __webpack_public_path__ + "schsafeTwo-5e153628e613a3bbf2e0318579d8feb8.png";